import { Injectable } from "@angular/core";
import { AppConstants } from "src/app-constants";
import { AdditionalRequestDetails, Authentication } from "../internal-models/additional-request-details";
import { ApiRequest } from "../service-models/api-contracts/base/api-request";
import { ApiResponse } from "../service-models/api-contracts/base/api-response";
import { StorageService } from "../services/storage.service";
import { BaseApiClient } from "./base-client/base-api.client";
import { CommonResponseCodeHandler } from "./helpers/common-response-code-handler.helper";
import { StorageCache } from "./helpers/storage-cache.helper";
import { ContactSalesSM } from "../service-models/contact-sales.s-m";

@Injectable({
    providedIn: 'root'
})
export class ContactSalesClient extends BaseApiClient {
    constructor(storageService: StorageService, storageCache: StorageCache,
        commonResponseCodeHandler: CommonResponseCodeHandler) {
        super(storageService, storageCache, commonResponseCodeHandler)


    }
   /**Add a new contact sales form */
    AddContactSales = async (contactSalesRequest: ApiRequest<ContactSalesSM>): Promise<ApiResponse<ContactSalesSM>> => {
        let resp = await this.GetResponseAsync<ContactSalesSM, ContactSalesSM>
            (AppConstants.ApiUrls.DUMMY_CONTACTSALES_URL, 'POST', contactSalesRequest, 
            new AdditionalRequestDetails<ContactSalesSM>(false, Authentication.false));
        return resp;
    }
}